'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _inlineOverlayCloseButton = require('../../inline-overlay-close-button');

var _inlineOverlayCloseButton2 = _interopRequireDefault(_inlineOverlayCloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineOverlayHeader = function InlineOverlayHeader(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'content-header' },
    _react2.default.createElement(
      _inlineOverlayCloseButton2.default,
      { className: 'close-top-right' },
      _react2.default.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      _react2.default.createElement(
        _baseScreenReaderMessage2.default,
        null,
        'Close'
      )
    ),
    title || children ? _react2.default.createElement(
      'h4',
      { className: 'content-title' },
      title || children
    ) : null
  );
};

InlineOverlayHeader.propTypes = {
  title: _react.PropTypes.string,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node])
};

InlineOverlayHeader.displayName = 'InlineOverlayHeader';

exports.default = InlineOverlayHeader;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-header/components/InlineOverlayHeader.component.js
// module id = 1322
// module chunks = 1